import React, { useState, useEffect } from "react";
import { userAPI } from "../../../api";
import AlertPopup from "../../../components/alert-popup/AlertPopup";
import WPLAnimatedInput from "../../../components/wpl-animated-input/WplAnimatedInput";
import { toStandardWplTimestamp } from "../../../prettyDate";
import ShowIcon from "../../../assets/eye.png";
import HideIcon from "../../../assets/closed-eye.png";
import TurbineAnimation from "../../../components/turbine-animation/TurbineAnimation";
import WplButton from "../../../components/wpl-button/WplButton";
import "./lightning-account-settings.css";

export default function LightningAccountSettings() {
  const [showPassword, setShowPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [alertPopupText, setAlertPopupText] = useState("");
  const [errorPopUp, setErrorPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [isBtnDisable, setIsBtnDisable] = useState(true);
  const errorMessages = {
    pwMatch: "The new passwords you entered don't match. Please try again.",
  };
  const [loading, setLoading] = useState(false);

  const handlePasswordUpdate = async () => {
    if (newPassword !== confirmNewPassword) {
      setErrorMessage(errorMessages.pwMatch);
      return;
    }
    setLoading(true);

    try {
      const timestamp = toStandardWplTimestamp(new Date());
      await userAPI.updatePassword(
        currentPassword,
        newPassword,
        confirmNewPassword,
        timestamp
      );
      setSuccessPopup(true);
      setErrorMessage("");
    } catch (error) {
      setAlertPopupText(error.response.data);
      setErrorPopup(true);
    } finally {
      setLoading(false);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    }
  };

  const validateInputs = () => {
    const isDisabled = !(currentPassword && newPassword && confirmNewPassword);
    setIsBtnDisable(isDisabled);

    if (newPassword && confirmNewPassword) {
      if (newPassword !== confirmNewPassword) {
        setErrorMessage(errorMessages.pwMatch);
        setIsBtnDisable(true);
      } else {
        setErrorMessage("");
      }
    } else {
      setErrorMessage("");
    }
  };

  useEffect(() => {
    validateInputs();
  }, [currentPassword, newPassword, confirmNewPassword]);

  return (
    <div className="account-settings-container">
      <h4>Update Password</h4>

      {loading && (
        <div className="overlay loading">
           <TurbineAnimation/>
        </div>
      )}
      <WPLAnimatedInput
        label="Current password"
        type={showPassword ? "text" : "password"}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
      />

      <WPLAnimatedInput
        label="New password"
        type={showPassword ? "text" : "password"}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <WPLAnimatedInput
        label="Repeat new password"
        type={showPassword ? "text" : "password"}
        value={confirmNewPassword}
        onChange={(e) => setConfirmNewPassword(e.target.value)}
      />

      {errorMessage === errorMessages.pwMatch && (
        <p className="error-message">{errorMessage}</p>
      )}

      <div
        className="show-password"
        onClick={() => setShowPassword(!showPassword)}
      >
        <img
          src={showPassword ? ShowIcon : HideIcon}
          alt="Password visibility toggle icon"
          className="toggle-icon"
        />
        <p className="toggle-label">
          {showPassword ? "Hide" : "Show"} Password
        </p>
      </div>

      <AlertPopup
        showPopup={successPopup}
        closePopup={setSuccessPopup}
        status={"success"}
        title={"Password updated!"}
        buttonText={"Proceed"}
      >
        <p className="success-message">Password successfully updated.</p>
      </AlertPopup>

      <AlertPopup
        showPopup={errorPopUp}
        closePopup={setErrorPopup}
        status={"wrong"}
        title={"Something went wrong..."}
        buttonText={"Go back"}
      >
        <p className="success-message">{alertPopupText}</p>
      </AlertPopup>

      <div className="btn-container">
        <WplButton
          value="Update"
          disabled={isBtnDisable}
          onClick={handlePasswordUpdate}
          className={`update-btn ${isBtnDisable ? "disabled" : ""}`}
        />
      </div>
    </div>
  );
}
